import { render, staticRenderFns } from "./CreateMark.vue?vue&type=template&id=b8e21244&"
import script from "./CreateMark.vue?vue&type=script&lang=js&"
export * from "./CreateMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports